// 电控
import Log from "../view/log";
import diDingNav from "../components/common/di-ding/pages/nav";
import electronicConfig from "../view/ElectronicControl/electronic-config/electronic-config";
import modifyElectronicConfig from "../view/ElectronicControl/electronic-config/modify-electronic-config";
import electronicStatistics from "../view/ElectronicControl/electronic-statistics/electronic-statistics";
import ElectronicManagementNav from "../view/ElectronicManagement/ElectronicManagementNav";
import ControllerManagement from "../view/ElectronicManagement/ControllerManagement/ControllerManagement";
import ControllerAdd from "../view/ElectronicManagement/ControllerManagement/ControllerAdd";
import ControllerCurrent from "../view/ElectronicManagement/ControllerManagement/ControllerCurrent";
import ControllerModify from "../view/ElectronicManagement/ControllerManagement/ControllerModify";
import ControllerDeviceStatusLog from "../view/ElectronicManagement/ControllerDeviceStatusLog/ControllerDeviceStatusLog";
import AmmeterManagement from "../view/ElectronicManagement/AmmeterManagement/AmmeterManagement";
import AmmeterAdd from "../view/ElectronicManagement/AmmeterManagement/AmmeterAdd";
import AmmeterCurrent from "../view/ElectronicManagement/AmmeterManagement/AmmeterCurrent";
import AmmeterModify from "../view/ElectronicManagement/AmmeterManagement/AmmeterModify";
import DeviceSceneConfig from "../view/ElectronicManagement/DeviceSceneConfig/DeviceSceneConfig";
import ElectronicConfigCenter from "../view/ElectronicManagement/ElectronicConfig/ElectronicConfigCenter";
import ElectronicConfigModify from "../view/ElectronicManagement/ElectronicConfig/ElectronicConfigModify";
import ElectronicAccountCenter from "../view/ElectronicManagement/ElectronicAccountConfig/ElectronicAccountCenter";
import ElectronicAccountModify from "../view/ElectronicManagement/ElectronicAccountConfig/ElectronicAccountModify";
import ElectronicPayRecord from "../view/ElectronicManagement/ElectronicPayRecord/ElectronicPayRecord";
import ElectronicRentMoney from "../view/ElectronicManagement/ElectronicRentMoney/ElectronicRentMoney";
import ElectricQuantity from "../view/ElectronicManagement/ElectricQuantity/ElectricQuantity";
import ElectricQuantityPublic from "../view/ElectronicManagement/ElectricQuantityPublic/ElectricQuantityPublic";
import ElectronicOverView from "../view/ElectronicManagement/OverView/OverView";
import settlementRecord from "../view/ElectronicManagement/settlementRecord/settlementRecord";
import ElectronicLog from "../view/ElectronicManagement/ElectrinicLog/ElectronicLog";
import ElectronicConfigSettle from "../view/ElectronicManagement/ElectronicConfigSettle/ElectronicConfigSettle";
import ElectricityMonitoring from "../view/ElectronicManagement/ElectricityMonitoring/ElectricityMonitoring";
import ElectricQuantityRoom from "../view/ElectronicManagement/ElectricQuantityRoom/ElectricQuantityRoom"

export default [
  /* 电控 */
  {
    path: "/electronic-control/face-config",
    name: "electronic-config",
    components: {
      default: diDingNav,
      a: electronicConfig
    }
  },
  {
    path: "/electronic-control/modify-config",
    name: "modify-electronic-config",
    components: {
      default: diDingNav,
      a: modifyElectronicConfig
    }
  },
  {
    path: "/electronic-control/electronic-statistics",
    name: "electronic-statistics",
    components: {
      default: diDingNav,
      a: electronicStatistics
    }
  },
  {
    path: "/controller_management",
    name: "controller-management",
    components: {
      default: ElectronicManagementNav,
      a: ControllerManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/controller_add",
    name: "controller-add",
    components: {
      default: ElectronicManagementNav,
      a: ControllerAdd
    }
  },
  {
    path: "/controller_modify/:id",
    name: "controller-modify",
    components: {
      default: ElectronicManagementNav,
      a: ControllerModify
    }
  },
  {
    path: "/controller_device_status_log",
    name: "controller-device-status-log",
    components: {
      default: ElectronicManagementNav,
      a: ControllerDeviceStatusLog
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/controller_current/:id",
    name: "controller-current",
    components: {
      default: ElectronicManagementNav,
      a: ControllerCurrent
    }
  },
  {
    path: "/ammeter_management",
    name: "ammeter-management",
    components: {
      default: ElectronicManagementNav,
      a: AmmeterManagement
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/ammeter_add",
    name: "ammeter-add",
    components: {
      default: ElectronicManagementNav,
      a: AmmeterAdd
    }
  },
  {
    path: "/ammeter_current/:id",
    name: "ammeter-current",
    components: {
      default: ElectronicManagementNav,
      a: AmmeterCurrent
    }
  },
  {
    path: "/ammeter_modify/:id",
    name: "ammeter-modify",
    components: {
      default: ElectronicManagementNav,
      a: AmmeterModify
    }
  },
  {
    path: "/device_scene_config",
    name: "device-scene-config",
    components: {
      default: ElectronicManagementNav,
      a: DeviceSceneConfig
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/electronic_config_center",
    name: "electronic-config-center",
    components: {
      default: ElectronicManagementNav,
      a: ElectronicConfigCenter
    }
  },
  {
    path: "/electronic_config_settle",
    name: "electronic-config-settle",
    components: {
      default: ElectronicManagementNav,
      a: ElectronicConfigSettle
    }
  },
  {
    path: "/electronic_config_modify",
    name: "electronic-config-modify",
    components: {
      default: ElectronicManagementNav,
      a: ElectronicConfigModify
    }
  },
  {
    path: "/electronic_account_center",
    name: "electronic-account-center",
    components: {
      default: ElectronicManagementNav,
      a: ElectronicAccountCenter
    }
  },
  {
    path: "/electronic_account_modify",
    name: "electronic-account-modify",
    components: {
      default: ElectronicManagementNav,
      a: ElectronicAccountModify
    }
  },
  {
    path: "/electronic_pay_record",
    name: "electronic-pay-record",
    components: {
      default: ElectronicManagementNav,
      a: ElectronicPayRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/settlement_record",
    name: "settlement-record",
    components: {
      default: ElectronicManagementNav,
      a: settlementRecord
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/electronic_rent_money",
    name: "electronic-rent-money",
    components: {
      default: ElectronicManagementNav,
      a: ElectronicRentMoney
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/electric_quantity",
    name: "electric-quantity",
    components: {
      default: ElectronicManagementNav,
      a: ElectricQuantity
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/electric_quantity_public",
    name: "electric-quantity-public",
    components: {
      default: ElectronicManagementNav,
      a: ElectricQuantityPublic
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/electric_quantity_room",
    name: "electric-quantity-room",
    components: {
      default: ElectronicManagementNav,
      a: ElectricQuantityRoom
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/electricity_monitoring",
    name: "electricity-monitoring",
    components: {
      default: ElectronicManagementNav,
      a: ElectricityMonitoring
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/electronic_log",
    name: "electronic-log",
    components: {
      default: ElectronicManagementNav,
      a: ElectronicLog
    }
  },
  {
    path: "/electronic/over_view",
    name: "electronic-over-view",
    components: {
      default: ElectronicManagementNav,
      a: ElectronicOverView
    }
  },
  /* 电控 */

  // 智慧用电操作日志
  {
    path: "/electronic_control_log",
    name: "electronic-control-log",
    components: {
      default: ElectronicManagementNav,
      a: Log
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/ElectronicControl.js